import React from "react";


function SingleSelectFieldRenderer(props) {
  const config = props.field?.config || {};
  const options = Array.isArray(config.options) ? config.options : [];

  const current =
    props.value && typeof props.value.option === "string" ? props.value.option : null;

  const handleSelect = (opt) => {
    if (props.disabled) return;
    if (opt === current) {
      props.onChange(null);
    } else {
      props.onChange({ option: opt });
    }
  };

  if (options.length === 0) {
    return (
      <p className="text-xs italic text-slate-500">
        No options configured for this field.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {options.map((opt) => {
        const isSelected = opt === current;
        return (
          <button
            key={opt}
            type="button"
            onClick={() => handleSelect(opt)}
            disabled={props.disabled}
            className={`text-left px-3 py-2 rounded-lg text-sm border transition-colors ${
              isSelected
                ? "bg-violet-600 border-violet-600 text-white"
                : "bg-white border-slate-300 text-slate-700 hover:border-violet-400"
            } ${props.disabled ? "opacity-60 cursor-not-allowed" : ""}`}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}

export default SingleSelectFieldRenderer;
